import { Button, Col, Form, Input, Row, Select, Tag, notification } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getGioiThieuUngVien,
  UpSertGioiThieuUngVien,
  getAllThietLap,
} from "store/slices/tuyenDungSlice";
import { getDanhMucChuyenMon } from "store/slices/thietLapKhac/chuyenMonCategorySlice";
import { GetSangKienCate } from "store/slices/sangKienYTuongSlice";
import { GIOITHIEU_STT_OPTIONS } from "constants";
import SlipModalComponent from "components/SlipModalComponent";
import SlipTag from "components/SlipTag";

const CHUNG_CHI_OPTIONS = [
  { value: true, label: "Đã có" },
  { value: false, label: "Chưa có" },
];


export default function ModalUngVien({ visibleModal, setVisibleModal, maHoSo, setMaHoSo, loading, reloadData, viewOnly, setViewOnly }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const childRef = useRef(null);

  const { branchId } = useSelector((state) => state.auth);
  const { GioiThieuUngVienDetail, ThietLapTuyenDungList } = useSelector((state) => state.tuyenDung);
  const { danhMucChuyenMonListSetting } = useSelector((state) => state.chuyenMonCategory);
  const { branchList } = useSelector((state) => state.sangKienYTuong);

  const isEdit = !isEmpty(maHoSo);

  useEffect(() => {
    dispatch(getAllThietLap(5));
    dispatch(getDanhMucChuyenMon(branchId));
    dispatch(GetSangKienCate());
  }, [dispatch, branchId]);

  useEffect(() => {
    if (!visibleModal) return;
    if (!isEdit) {
      form.resetFields();
      form.setFieldValue("trangThai", 1);
      return;
    }
    dispatch(getGioiThieuUngVien(maHoSo));
  }, [visibleModal, maHoSo, isEdit, dispatch]);

  useEffect(() => {
    if (!isEdit || isEmpty(GioiThieuUngVienDetail)) return;
    form.setFieldsValue({
      ...GioiThieuUngVienDetail,
      chungChiHanhNghe: GioiThieuUngVienDetail.chungChiHanhNghe ?? false,
    });
  }, [GioiThieuUngVienDetail, isEdit, form]);

  const onFinish = (values) => {
    const { hoSoDisplay, ...rest } = values;
    const payload = {
      ...rest,
      id: maHoSo || null,
      chiNhanhUngTuyen: rest.chiNhanhUngTuyen || branchId,
      hoSoUngTuyen: [],
      onSuccess: ({ data }) => {
        if (!data?.isOk) {
          notification.error({ message: "Lỗi", description: data?.description });
          return;
        }
        notification.success({ message: "Lưu giới thiệu ứng viên thành công" });
        reloadData();
        setVisibleModal(false);
        setMaHoSo(null);
        form.resetFields();
      },
    };
    dispatch(UpSertGioiThieuUngVien(payload));
  };

  return (
    <>
      <SlipModalComponent
        ref={childRef}
        maskClosable={false}
        bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 300px)" }}
        width={900}
        titleTLink="Giới thiệu ứng viên"
        objectId={maHoSo}
        objectType="GioiThieuUngVien"
        title={viewOnly ? "Chi tiết ứng viên" : isEdit ? "Sửa giới thiệu ứng viên" : "Thêm giới thiệu ứng viên"}
        isVisibleModal={visibleModal}
        onCancelModal={() => {
          setVisibleModal(false);
          setMaHoSo(null);
          setViewOnly(false);
          form.resetFields();
        }}
        onRenderInfo={() => (
          <Form className="p-3" form={form} layout="vertical" onFinish={onFinish}>
            {isEdit && (
              <>
                <Row gutter={12}>
                  <Col sm={24} md={24} lg={24}>
                    <Form.Item label="Mã giới thiệu">
                      <SlipTag
                        options={GIOITHIEU_STT_OPTIONS}
                        data={GioiThieuUngVienDetail}
                        keyCode="maGioiThieu"
                        keyStatus="trangThai"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col sm={24} md={24} lg={24}>
                    <Form.Item label="Mã hồ sơ ứng viên">
                      <Input value={GioiThieuUngVienDetail?.maHoSoUV || "Chưa có hồ sơ"} disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            <Row gutter={12}>
              <Col sm={12} md={12} lg={12}>
                <Form.Item
                  name="tenUngVien"
                  label="Họ tên ứng viên"
                  rules={[{ required: true, message: "Vui lòng nhập họ tên ứng viên" }]}
                >
                  <Input placeholder="Nhập họ tên" disabled={viewOnly} />
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12}>
                <Form.Item
                  name="phoneUngVien"
                  label="SĐT ứng viên"
                  rules={[
                    { required: true, message: "Vui lòng nhập SĐT ứng viên" },
                    { pattern: /^[0-9]{9,11}$/, message: "SĐT không hợp lệ" },
                  ]}
                >
                  <Input placeholder="Nhập số điện thoại" disabled={viewOnly} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={12}>
              <Col sm={12} md={12} lg={12}>
                <Form.Item
                  name="emailUngVien"
                  label="Email ứng viên"
                  rules={[{ type: "email", message: "Email không hợp lệ" }]}
                >
                  <Input placeholder="Nhập email (nếu có)" disabled={viewOnly} />
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12}>
                <Form.Item name="moiQuanHe" label="Mối quan hệ">
                  <Input placeholder="Nhập mối quan hệ" disabled={viewOnly} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={12}>
              <Col sm={12} md={12} lg={12}>
                <Form.Item name="viTriUngTuyenId" label="Vị trí ứng tuyển"
                  rules={[
                    { required: true, message: "Vui lòng chọn vị trí ưng tuyển" },
                  ]}>
                  <Select
                    showSearch
                    allowClear
                    placeholder="Chọn vị trí"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={(ThietLapTuyenDungList || []).filter((t) => t.status).map((t) => ({ value: t.id, label: t.tenThietLap }))}
                    disabled={viewOnly}
                  />
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12}>
                <Form.Item name="chuyenMonId" label="Chuyên môn"
                  rules={[
                    { required: true, message: "Vui lòng chọn chuyên môn" },
                  ]}>
                  <Select
                    showSearch
                    allowClear
                    placeholder="Chọn chuyên môn"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={(danhMucChuyenMonListSetting || []).filter((m) => m.id).map((m) => ({ value: m.id, label: m.name }))}
                    disabled={viewOnly}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={12}>
              <Col sm={12} md={12} lg={12}>
                <Form.Item name="chungChiHanhNghe" label="Chứng chỉ hành nghề">
                  <Select options={CHUNG_CHI_OPTIONS} placeholder="Chọn" disabled={viewOnly} />
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12}>
                <Form.Item
                  name="soCchn"
                  label="Số CCHN"
                  dependencies={["chungChiHanhNghe"]}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (getFieldValue("chungChiHanhNghe") === true && !value) {
                          return Promise.reject(new Error("Vui lòng nhập số CCHN"));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input placeholder="Nhập số CCHN (nếu có)" disabled={viewOnly} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={12}>
              <Col sm={12} md={12} lg={12}>
                <Form.Item name="khoaPhongId" label="Cơ sở muốn làm việc"
                  rules={[
                    { required: true, message: "Vui lòng chọn cơ sở làm việc" },
                  ]}>
                  <Select
                    showSearch
                    allowClear
                    placeholder="Chọn cơ sở"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={(branchList || []).map((m) => ({ value: m.value ?? m.id, label: m.label ?? m.name }))}
                    disabled={viewOnly}
                  />
                </Form.Item>
              </Col>

              <Col sm={12} md={12} lg={12}>
                <Form.Item name="trangThai" label="Trạng thái">
                  <Select
                    options={GIOITHIEU_STT_OPTIONS.map((o) => ({ value: o.id, label: o.name }))}
                    disabled={viewOnly}
                  />
                </Form.Item>
              </Col>

            </Row>

            {!viewOnly && (
              <Row gutter={12}>
                <Col sm={24}>
                  <Button type="primary" onClick={() => form.submit()}>
                    Lưu
                  </Button>
                </Col>
              </Row>
            )}
          </Form>
        )}
      />

    </>
  );
}
